import { IconButton } from '@mui/material'
import { ChevronLeft } from '@mui/icons-material'

import { ListHeaderCounter, ListHeaderTitle, ListHeaderTitleContainer } from '@/components/List'

import { useTexts } from './hooks/useTexts'
import { useTitle } from './hooks/useTitle'

export function Title() {
  const { editing, selection, listStructure, onSelectAll, onGoBack } = useTitle()

  const texts = useTexts()

  return (
    <ListHeaderTitleContainer>
      <IconButton size="small" onClick={onGoBack}>
        <ChevronLeft fontSize="inherit" />
      </IconButton>

      <ListHeaderTitle>{texts.title}</ListHeaderTitle>

      <ListHeaderCounter
        allSelected={selection.length >= listStructure.shownItems}
        disabled={editing}
        onClick={onSelectAll}
        readonly={listStructure.totalItems === 0}
      >
        {listStructure.shownItems}
      </ListHeaderCounter>
    </ListHeaderTitleContainer>
  )
}
